import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { initializeBranding } from './branding-utils';

/**
 * Re-runs brand detection on every route change.
 * The activeBrand guard in initializeBranding() makes this a no-op
 * when the brand hasn't changed, so it's safe on every navigation.
 *
 * Place once near the top of the component tree (inside BrowserRouter)
 * to cover both signed-in and signed-out routes.
 */
export const BrandSync = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    initializeBranding();
  }, [pathname]);

  return null;
};
